import classnames from "classnames"
import { motion } from "framer-motion"
import assign from "lodash/assign"
import { useUIThemeContext } from "../ui/PathwrightUI"
import { hexToRgba, parseRgba } from "../utils/colors"
import "./AnimatedIcon.css"
import Pathicon from "./Pathicon"

// Approximate Velocity UI Pack transitions previously used here:
// background: transition.shrinkOut, border: transition.shrinkIn, icon: transition.expandIn
const BACKGROUND_MOTION = {
  initial: { opacity: 1, scale: 1 },
  animate: { opacity: 0, scale: 1.3 },
  transition: { duration: 0.6, delay: 0, ease: "easeOut" }
}
const BORDER_MOTION = {
  initial: { opacity: 0, scale: 1.5 },
  animate: { opacity: 1, scale: 1 },
  transition: { duration: 0.75, delay: 0.1, ease: "easeOut" }
}
const ICON_MOTION = {
  initial: { opacity: 0, scale: 0.625 },
  animate: { opacity: 1, scale: 1 },
  transition: { duration: 0.2, delay: 0.4, ease: "easeOut" }
}

const AnimatedIcon = (props) => {
  const {
    icon = "check",
    inverted,
    iconSize = 40,
    circleSize = 80,
    brand,
    color: colorProp = "#000"
  } = props

  const styles = {
    fontSize: iconSize,
    width: circleSize,
    height: circleSize,
    borderRadius: circleSize / 2
  }

  const className = classnames("AnimatedIcon", props.className)
  const theme = useUIThemeContext()
  const color = brand ? theme.primaryBrandColor : inverted ? "#fff" : colorProp
  const backgroundStyles = assign({}, styles, {
    backgroundColor: parseRgba(hexToRgba(color, inverted ? 0.3 : 0.1))
  })
  const borderStyles = assign({}, styles, {
    borderColor: color
  })
  const iconStyles = { color }

  return (
    <div className={className} style={styles}>
      <motion.div
        className="AnimatedIcon__background"
        style={backgroundStyles}
        initial={BACKGROUND_MOTION.initial}
        animate={BACKGROUND_MOTION.animate}
        transition={BACKGROUND_MOTION.transition}
      />
      <motion.div
        className="AnimatedIcon__border"
        style={borderStyles}
        initial={BORDER_MOTION.initial}
        animate={BORDER_MOTION.animate}
        transition={BORDER_MOTION.transition}
      />
      <motion.div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        initial={ICON_MOTION.initial}
        animate={ICON_MOTION.animate}
        transition={ICON_MOTION.transition}
      >
        <Pathicon
          className="AnimatedIcon__icon"
          icon={icon}
          style={iconStyles}
        />
      </motion.div>
    </div>
  )
}

AnimatedIcon.displayName = "AnimatedIcon"

export default AnimatedIcon
